/* eslint-disable react/destructuring-assignment */
import React from "react";
import { useParams } from "react-router-dom";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomData from "pages/_components/CustomData/CustomData";
import { useSelector } from "react-redux";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import { bool } from "prop-types";
import getCellPlacement from "../../../../util/helpers/table";

const DataDetailDiscounts = ({ isDesktop }) => {
    const { echeqDocuments, transactionsEcheqDiscount } = useSelector((_state) => _state.discounts);

    const { id } = useParams();

    const dataLot = transactionsEcheqDiscount?.find((item) => item.idTransaction === id);
    const totalComission = echeqDocuments.reduce((accumulator, echeq) => accumulator + echeq?.taxes?.commission, 0);
    const totalTaxVat = echeqDocuments.reduce((accumulator, echeq) => accumulator + echeq?.taxes?.taxVat, 0);
    const totalTaxVatPerception = echeqDocuments.reduce(
        (accumulator, echeq) => accumulator + echeq?.taxes?.taxVatPerception,
        0,
    );
    const totalInterest = echeqDocuments.reduce((accumulator, echeq) => accumulator + echeq?.taxes?.interest, 0);

    const totalSeal = echeqDocuments[0]?.taxes.taxStamp;
    const totalIIBB = echeqDocuments[0]?.taxes.taxIIBB;

    const getCellProps = (row, col) => getCellPlacement(row, col, { isDesktop });

    return (
        <>
            <GridTable className="details debin-credin-list">
                <GridTable.Container columns={3} rows={4}>
                    <GridTable.Data columnStart={1} rowStart={1} columnWidth={1}>
                        <CustomData
                            titleText="detail.discounts.solicitor"
                            titleTextType="I18N"
                            valueText={dataLot?.solicitor}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnWidth={1} {...getCellProps(1, 2)}>
                        <CustomData
                            titleText="detail.discounts.discountAmount"
                            titleTextType="I18N"
                            valueText={
                                <FormattedAmount
                                    currency={dataLot?.amount?.currency}
                                    quantity={dataLot?.amount?.quantity}
                                />
                            }
                            valueTextType="TEXT"
                        />
                    </GridTable.Data>
                    <GridTable.Data columnWidth={1} {...getCellProps(1, 3)}>
                        <CustomData
                            titleText="detail.discounts.totalEffectiveAmount"
                            titleTextType="I18N"
                            valueText={
                                <FormattedAmount
                                    currency={dataLot?.effectiveAmount?.currency}
                                    quantity={dataLot?.effectiveAmount?.quantity}
                                />
                            }
                            valueTextType="TEXT"
                        />
                    </GridTable.Data>

                    <GridTable.Data columnStart={1} rowStart={isDesktop ? 2 : 4} columnWidth={1}>
                        <CustomData
                            titleText="detail.discounts.creditAccount"
                            titleTextType="I18N"
                            valueTextType="TEXT"
                            valueText={dataLot?.account}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 2 : 5} columnWidth={1}>
                        <CustomData
                            titleText="detail.discounts.documentQuantity"
                            titleTextType="I18N"
                            valueTextType="TEXT"
                            valueText={echeqDocuments?.length ?? 0}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 2 : 6} columnWidth={1}>
                        <CustomData
                            titleText="detail.discounts.processDate"
                            titleTextType="I18N"
                            valueTextType="TEXT"
                            valueText={<FormattedDate date={dataLot?.dateEmitted} dateFormat="DD/MM/YYYY HH:MM:SS" />}
                        />
                    </GridTable.Data>

                    <GridTable.Data columnStart={1} rowStart={isDesktop ? 3 : 7} columnWidth={1}>
                        <CustomData
                            titleText="detail.discounts.totalCommission"
                            titleTextType="I18N"
                            valueTextType="TEXT"
                            valueText={<FormattedAmount currency="ARS" quantity={totalComission} />}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 3 : 8} columnWidth={1}>
                        <CustomData
                            titleText="detail.discounts.totalTaxVat"
                            titleTextType="I18N"
                            valueTextType="TEXT"
                            valueText={<FormattedAmount currency="ARS" quantity={totalTaxVat} />}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 3 : 9} columnWidth={1}>
                        <CustomData
                            titleText="detail.discounts.totalTaxVatPerception"
                            titleTextType="I18N"
                            valueTextType="TEXT"
                            valueText={<FormattedAmount currency="ARS" quantity={totalTaxVatPerception} />}
                        />
                    </GridTable.Data>

                    <GridTable.Data columnStart={1} rowStart={isDesktop ? 4 : 10} columnWidth={1}>
                        <CustomData
                            titleText="detail.discounts.totalInterest"
                            titleTextType="I18N"
                            valueTextType="TEXT"
                            valueText={<FormattedAmount currency="ARS" quantity={totalInterest} />}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 4 : 11} columnWidth={1}>
                        <CustomData
                            titleText="detail.discounts.totalIIBB"
                            titleTextType="I18N"
                            valueTextType="TEXT"
                            valueText={<FormattedAmount currency="ARS" quantity={totalIIBB} />}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 4 : 12} columnWidth={1}>
                        <CustomData
                            titleText="detail.discounts.totalSeal"
                            titleTextType="I18N"
                            valueTextType="TEXT"
                            valueText={<FormattedAmount currency="ARS" quantity={totalSeal} />}
                        />
                    </GridTable.Data>
                </GridTable.Container>
            </GridTable>
        </>
    );
};

DataDetailDiscounts.propTypes = {
    isDesktop: bool.isRequired,
};

export default DataDetailDiscounts;
